import { render, staticRenderFns } from "./CollegeSubscriptionStudents.vue?vue&type=template&id=8e5a2ac2"
import script from "./CollegeSubscriptionStudents.vue?vue&type=script&lang=js"
export * from "./CollegeSubscriptionStudents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports